import assign from 'object-assign';
import makeGuid from '@util/guid';
import {createSearchContext} from '@ultradent/upi-fuzzy-search';
import Class from '@core/Class';
import Module from '@core/Module';
import View from '@core/View';
import Events from '@core/Events';

var guid = makeGuid(),
    defaults = {
        label: 'Filter',
        hint: '',
        placeholder: '',
        queryNode: '> li',
        template: 'filterForm',
        fieldSelector: '.SearchForm-field',
        noResultsSelector: '.SearchForm-noResults',
        clearButtonSelector: '.SearchForm-clear'
    },
    option;

var FilteredSearch = (Class.extend( Module, Events )).extend( {

    init: function ( el, opt ) {
        option = assign( {}, defaults, opt );

        this.$el = $( el );
        this.$nodeList = this.$el.find( option.queryNode );
        this.searchFormView = new View( option.template );

        // patch for addresses
        // this filter module is only being used for addresses, this is a fix to resolve search issues
        // on current address books where innerText breaks onto multiple lines
        // This breaks each newline into a separate property to be queried on by
        // attaching this data as an expando property on the DOM node
        this.$nodeList.each( ( i, item ) => {
            const meta = item.innerText.split( '\n' );
            item.meta1 = meta[0];
            item.meta2 = meta[1];
            item.meta3 = meta[2];
            item.meta4 = meta[3];
        } );

        this.context = createSearchContext( this.$nodeList, ['meta1', 'meta2', 'meta3', 'meta4'] );

        this.searchFormView.whenTemplatesLoaded.then( () => {
            var tmpl = this.searchFormView.render( {
                guid: guid,
                label: option.label,
                hint: option.hint,
                placeholder: option.placeholder
            } );

            this.$form = $( tmpl );
            this.$searchField = this.$form.find( option.fieldSelector );
            this.$noResults = this.$form.find( option.noResultsSelector );
            this.$form.insertBefore( this.$el );
            this.focus();

            this.$form.on( 'keyup', option.fieldSelector, this.handleKeyEvent.bind( this ) );
            this.$form.on( 'keypress', option.fieldSelector, this.handleKeyEvent.bind( this ) );
            this.$form.on( 'click', option.clearButtonSelector, this.clearResults.bind( this ) );
        } );
    },

    clearResults: function () {
        this.$nodeList.show();
        this.$searchField.val( '' ).focus();
        this.toggleNoResults( false );
    },

    focus: function () {
        this.$searchField.focus();
    },

    blur: function () {
        this.$searchField.blur();
    },

    toggleNoResults: function ( doShow ) {
        this.$noResults.toggleClass( 'hidden', !doShow );
    },

    search: function ( query ) {
        const {results} = this.context.query( query );
        console.log( 'RESULTS:', results );
        return $( results );
    },

    handleKeyEvent: function ( e ) {
        if ( e.which === 13 ) {
            e.preventDefault();
            return false;
        }

        // hide all, reveal valid results
        var results = this.search( this.$searchField.val().trim() ).show();
        var visibleNodes = this.$nodeList.not( ':hidden' ).not( results ).hide();
        this.toggleNoResults( !results.length );
    }
} );

export default FilteredSearch;
